import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NriRoutingModule } from './nri-routing.module';
import { SharedModule } from '../shared/shared.module';
import { NriMembersListComponent } from './nri-cities/nri-members-list.component';
@NgModule({
  declarations: [
    NriMembersListComponent
  ],
  imports: [
    CommonModule,
    NriRoutingModule,
    SharedModule
  ]
})
export class NRIModule { }